export type { EquipmentMasterProps } from './equipment-master';
export * from './equipment-master.routes';

export { default as EquipmentMaster, default } from './equipment-master';
